module.exports = __webpack_public_path__ + "static/66b894995b847b78b68d27730d8afe160639866d25bddf947494960907ff234b-e22b8eb7d12d0477d6c2afac084151f5.jpeg";